import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { ProcesPage } from "@/pages/proces";

export const Route = createFileRoute("/$lang/processus")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/proces",
      title: t("proces.title"),
      description: t("proces.description"),
    });
  },
  component: ProcesPage,
});
